var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentsStepCompleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-7350025 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33 61.875C17.0775 61.875 4.125 48.9225 4.125 33C4.125 17.0775 17.0775 4.125 33 4.125C48.9225 4.125 61.875 17.0775 61.875 33C61.875 48.9225 48.9225 61.875 33 61.875ZM33 8.25C19.3457 8.25 8.25 19.3457 8.25 33C8.25 46.6543 19.3457 57.75 33 57.75C46.6543 57.75 57.75 46.6543 57.75 33C57.75 19.3457 46.6543 8.25 33 8.25ZM31.2262 45.3546C31.7831 45.2722 32.2987 44.9628 32.6287 44.4884L47.0662 23.8634C47.7262 22.9353 47.4994 21.6359 46.5506 20.9965C45.6225 20.3365 44.3231 20.5634 43.6838 21.5121L30.5041 40.3425L21.9037 33.4746C21.0169 32.7528 19.7175 32.9178 18.9956 33.8046C18.2944 34.6915 18.4388 35.9909 19.3256 36.7128L29.6381 44.9628C30.0094 45.2515 30.4631 45.4165 30.9169 45.4165C31.02 45.4165 31.1025 45.4165 31.2056 45.3959L31.2262 45.3546Z",
    fill: "#14AA40"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsStepCompleteIcon);
export default __webpack_public_path__ + "static/media/DocumentsStepCompleteIcon.e32225902cb4749bf5d2b8acdea0418c.svg";
export { ForwardRef as ReactComponent };